<template>
  <div>
    <table id="report-table">
      <tr class="title">
        <td style="width: 30px">
          <Checkbox  @on-change="selectAll" :value="ischeckAll"></Checkbox>
        </td>
        <td style="width: 120px">订单编号</td>
        <td style="width: 120px">接收时间</td>
        <td style="width: 40px">姓名</td>
        <td style="width: 80px">医院名称</td>
        <td style="width: 60px">送检医生</td>
        <td style="width: 60px">订单状态</td>
        <td style="width: 40px">备注</td>
        <td style="width: 100px">检验条码</td>
        <td style="width: 120px">项目名称</td>
        <td style="width: 130px">报告时间</td>
        <td style="width: 60px">打印状态</td>
        <td style="width: 180px">操作</td>
      </tr>
      <tbody v-if="getTable.length==0">
        <tr>
          <td colspan="11">暂时没有数据</td>
        </tr>
      </tbody>
      <tbody else id="td" v-for="(item,index) in getTable" :key="index">
        <tr>
          <td :rowspan="item.orderReport.length">
            <Checkbox
              :value="item.checked"
              @on-change="$emit('selectItem',item.orderId)"
            ></Checkbox>
          </td>
          <td :rowspan="item.orderReport.length">{{item.orderCode}}</td>
          <td :rowspan="item.orderReport.length">{{item.submitTime|formatDate('01','03')}}</td>
          <td :rowspan="item.orderReport.length">{{item.patientName}}</td>
          <td style="white-space: nowrap;"
            :rowspan="item.orderReport.length"
            :title="item.hospitalName?item.hospitalName:''"
          >{{item.hospitalName}}</td>
          <td :rowspan="item.orderReport.length">{{item.doctorName}}</td>
          <td :rowspan="item.orderReport.length">{{item.processStateName}}</td>
          <td :rowspan="item.orderReport.length">{{item.remark}}</td>
          <td>{{item.orderReport[0]?item.orderReport[0].specimenBarcode:""}}</td>
          <td
            :title="item.orderReport[0]?item.orderReport[0].projectName:''"
          >{{item.orderReport[0]?item.orderReport[0].projectName:""}}
          </td>
          <td>{{item.orderReport[0]?item.orderReport[0].reportTime:""|formatDate('01','03')}}</td>  
          <td>{{item.orderReport[0]?item.orderReport[0].printState:""}}</td>
          <!-- :rowspan="item.orderReport.length==0?1:item.orderReport.length" -->
            <td v-if="item.orderReport.length==0?1:item.orderReport.length">
              <span @click="printReport(item.orderReport,item.reportTitle,item.orderReport[0].orderReportId)">预览</span> 
              <span @click="SeeReport(item.orderReport,item.reportTitle,item.orderReport[0].orderReportId)">打印</span> 
              <span @click="LODOPSeeport(item.orderReport,item.reportTitle,item.orderReport[0].orderReportId)">LODOP打印</span>
            </td>
        </tr>
        <template v-for="(m,i) in item.orderReport">
          <tr :key="i" v-if="!i==0">
            <td>{{m.specimenBarcode}}</td>
            <td>{{m.projectName}}</td>
            <td>{{m.reportTime|formatDate('01','03')}}</td>
            <td>{{m.printState}}</td>
             <td>
            <span @click="printReport11(m,m.orderReportId)">预览</span> 
            <span @click="SeeReport11(m,m.orderReportId)">打印</span>
            <span @click="LODOPSeeport11(m,m.orderReportId)">LODOP打印11</span>
          </td>
            <!-- <td> 
              {{m.orderReportId}}
              <span @click="orderDetail(item.partnerOrderId)">订单详情</span>
             <span @click="printReport(m,item.reportTitle,m.orderReportId)">报告</span> 
            </td> -->
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { isSingleItem } from '../../api/clinic';
import { formatDate, tips } from "./../../tools";
export default {
  name: "reportTable",
  props:{
      getTable:{
          type:Array,
          default:()=>[]
      },
      ischeckAll:{
        type:Boolean
      }
  },
  filters: {
    formatDate
  },
  mounted(){},
  methods: {
    selectAll(e){
        this.$emit('selectAll',e);
    },
    printReport(arr, reportTitle,orderReportId) {
      console.log(arr, reportTitle,orderReportId)
      this.$emit('printReport',{arr,reportTitle,orderReportId});
    },
    printReport11(m,orderReportId){
      console.log(m,orderReportId)
      this.$emit('printReport11',{m,orderReportId});
    },
    SeeReport11(m,orderReportId){
      this.$emit('SeeReport11',{m,orderReportId});
    },
    SeeReport(arr, reportTitle,orderReportId){
      this.$emit('SeeReport',{arr, reportTitle,orderReportId})
    },
    orderDetail(id) {
      this.$emit('detail',id)
    },
    LODOPSeeport(arr, reportTitle,orderReportId){
      this.$emit('LODOPSeeport',{arr, reportTitle,orderReportId})
    },
    LODOPSeeport11(m,orderReportId){
      this.$emit('LODOPSeeport11',{m,orderReportId});
    },
  }
};
</script>
       
<style lang='less' scoped>
table,
td {
  border: 1px solid #ddd;
}
#report-table {
  border-collapse: collapse;
  width: 100%;
  overflow-y: auto;
}
#report-table,
#report-table th,
#report-table td {
  border: 1px solid #e8eaec;
  text-align: center;
}
#report-table span {
  cursor: pointer;
  text-align: center;
  margin: 0px 5px;
  // border: 1px solid rgb(39, 120, 231);
  // color: rgb(39, 120, 231);
  border: 1px solid #3985BE;
  color:  #3985BE;
  padding: 0 7px;
  font-size: 12px;
  border-radius: 3px;
  white-space: nowrap;
  height: 32px;
  line-height: 32px;
  display: inline-block;
}

#report-table td,
#report-table {
  padding: 10px 0;
}
#report-table {
  background-color: #fff;
}
#report-table .title {
  background-color: #f8f9fb;
}
table {-
  table-layout: fixed;
}
td {
        
  // white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media screen and (max-width: 1600px){
    #report-table{
        font-size: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/report/YnTable.vue